import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import SoftCheckDecision from './SoftCheckDecision';
import RequestSoftCheck from './RequestSoftCheck';
import ContinueButton from '../../../common/components/Buttons/ContinueButton';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
    },
    button: {
        marginLeft: unit * 2,
        '&:first-child': {
            marginLeft: 0,
        },
    },
    buttons: {
        marginTop: unit * 2,
        marginBottom: unit * 2,
    },
    buttonsCentered: {
        textAlign: 'center',
    },
});

function SoftCheck(props) {
    const goToNextStep = () => {
        props.setStep(5);
        props.setStepCompleted(4, true);
    };
    const setAcceptedIncomeCheck = () => {
        props.setAcceptedIncomeCheck(!props.consents.acceptedIncomeCheck);
    };
    const setAcceptedSoftCheck = () => {
        props.setAcceptedSoftCheck(!props.consents.acceptedSoftCheck);
    };
    return (
        <div>
            {props.softCheckCompleted &&
            <SoftCheckDecision
                isPending={props.isPending}
                decision={props.decision}
                maxLendAmount={props.maxLendAmount}
                applicant={props.applicant}
            />
            }
            {!props.softCheckCompleted &&
            <RequestSoftCheck
                setAcceptedIncomeCheck={setAcceptedIncomeCheck}
                setAcceptedSoftCheck={setAcceptedSoftCheck}
                consents={props.consents}
            />
            }
            <div className={[props.classes.buttons, props.softCheckCompleted && props.decision === 'allow' ? props.classes.buttonsCentered : ''].join(' ')}>
                <Button
                    className={props.classes.button}
                    color="default"
                    onClick={() => {
                        props.setStep(3);
                    }}
                >
                    Back
                </Button>
                {!props.softCheckCompleted &&
                <ContinueButton
                    className={props.classes.button}
                    disabled={(
                        !props.consents.acceptedSoftCheck || !props.consents.acceptedIncomeCheck
                    )}
                    onClick={() => {
                        props.requestSoftCheck({
                            applicantId: props.applicantId,
                            applicant: {
                                ...props.applicant,
                                mail: props.customer.mail,
                            },
                            application: props.application,
                            applicationId: props.applicationId,
                        });
                        props.setStepCompleted(4, true);
                    }}
                >
                    Accept &amp; Check
                </ContinueButton>
                }
                {props.softCheckCompleted && props.decision === 'allow' &&
                <ContinueButton
                    className={props.classes.button}
                    onClick={() => {
                        goToNextStep();
                    }}
                >
                    Proceed with underwriting
                </ContinueButton>
                }
            </div>
        </div>
    );
}

SoftCheck.propTypes = {
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    consents: PropTypes.object.isRequired,
    applicantId: PropTypes.string.isRequired,
    applicant: PropTypes.object.isRequired,
    applicationId: PropTypes.string.isRequired,
    application: PropTypes.object.isRequired,
    customer: PropTypes.object.isRequired,
    setAcceptedIncomeCheck: PropTypes.func.isRequired,
    setAcceptedSoftCheck: PropTypes.func.isRequired,
    requestSoftCheck: PropTypes.func.isRequired,
    decision: PropTypes.string.isRequired,
    maxLendAmount: PropTypes.object.isRequired,
    isPending: PropTypes.bool.isRequired,
    softCheckCompleted: PropTypes.bool.isRequired,
};

export default withStyles(styles)(SoftCheck);



// WEBPACK FOOTER //
// ./src/app/FormStepper/SoftCheck/components/SoftCheck.js